module.exports = __webpack_public_path__ + "img/img33.e8d31043.svg";